import data from './attrs/data'
import methods from './attrs/methods'
import mounted from './attrs/mounted'
import {VueEditor} from 'vue2-editor'
import DatePick from 'vue-date-pick'

export default {
  name: 'ModalForm',
  data,
  methods,
  mounted,
  components: {
    VueEditor,
    DatePick,
  }
}
